import { Component } from '@angular/core';
import { NgbScrollSpyModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import SharedModule from "../../shared/shared.module";

@Component({
  selector: 'jhi-faq',
  standalone: true,
  imports: [NgbScrollSpyModule, FormsModule, RouterLink, SharedModule],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss'
})
export class FaqComponent {
  baseUrl = SERVER_API_URL;
}
